<template>
  <span
    v-if="info.text"
    data-cy="import-progress"
    :class="['text-sm', info.error ? 'text-red-600' : 'text-gray-600']"
  >
    <i v-if="info.icon" class="fas fa-exclamation-circle mr-1" />{{ info.text }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { type ImportRow, progressInfo } from "@/DataImports/importsHubRows";

const props = defineProps<{ row: ImportRow }>();

const info = computed(() => progressInfo(props.row));
</script>
